module.exports = __webpack_public_path__ + "img/wfzc.c50eb2d.png";